import { Award } from "lucide-react";

// Badge Creator pubblico — visivamente distinto da ADE Pro (blu), Verified e Golden Ring (oro)
export const CreatorBadge = ({ user, className = "" }) => {
  if (user?.creator_status !== "approved") return null;
  return (
    <span
      className={`inline-flex items-center gap-1 px-1.5 py-0.5 rounded-md text-[9px] font-bold text-emerald-700 bg-emerald-50 border border-emerald-300 ${className}`}
      title="ADE Creator"
      data-testid="creator-badge"
    >
      <Award className="w-2.5 h-2.5" />
      CREATOR
    </span>
  );
};
